import React from "react";
import RespondBackSection from "pages/AssetRecovery/Descision/ReferralDecision/RespondBackSection";
import { AssetAppeal } from "types";
import RespondentAssetAppealDetails from "./RespondentAssetAppealDetails";

export default function RespondentAssetAppealDetailsContainer({
  appeal,
  fileRowProps,
  isAssetCoordinator,
  isAssetProsecutor,
  loading,
  isAssetRegistrar,
  setActiveTab,
  setAppeal,
}: {
  appeal?: AssetAppeal;
  fileRowProps: any;
  isAssetCoordinator: boolean;
  isAssetProsecutor: boolean;
  loading: boolean;
  isAssetRegistrar: boolean;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  setAppeal: React.Dispatch<React.SetStateAction<AssetAppeal | null>>;
}) {
  return (
    <div className="flex gap-3">
      <div className="w-3/5">
        <RespondentAssetAppealDetails
          appeal={appeal as AssetAppeal}
          isAssetCoordinator={isAssetCoordinator}
          isAssetProsecutor={isAssetProsecutor}
          loading={loading}
          setActiveTab={setActiveTab}
          setAppeal={setAppeal}
          fileRowProps={fileRowProps}
          isAssetRegistrar={isAssetRegistrar}
        />
      </div>
      <div className=" w-2/5">
        <RespondBackSection
          appealId={appeal?.id}
          fileRowProps={fileRowProps}
          referralId=""
          type="appeal-respondent"
        />
      </div>
    </div>
  );
}
